import axios from "axios";
import Constants from "@/services/Constants";

export default {
	async getDownloads() {
		let res = await axios.get(`${Constants.backend}/downloads/`);
		return res.data;
	}
}